export default __webpack_public_path__ + "static/media/Download.b0337b4b.png";